import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "toggle"];
  static expanded = true;

  connect() {
    this.expanded = true;
  }

  toggle() {
    const chevron = this.toggleTarget.querySelector("svg");

    if (this.expanded) {
      chevron.classList.add("rotate-180");
      this.contentTarget.style.gridTemplateRows = "0fr";
    } else {
      chevron.classList.remove("rotate-180");
      this.contentTarget.style.gridTemplateRows = "1fr";
    }

    this.expanded = !this.expanded;
  }
}
